'use client';
import { useEffect } from 'react';

import { reloadOnChunkError } from '@/util/chunk-reload';

/**
 * Catches ChunkLoadErrors caused by a Next.js 13 bug where dynamic route
 * segment names (e.g. [slug]) get double URL-encoded in the RSC chunk
 * manifest, making SPA navigation fail with a 404 for the chunk file.
 *
 * When caught, reloads the page so the full server-rendered version loads
 * instead. Fixed in Next.js 14 — remove this when upgrading.
 */
export default function ChunkErrorReloader() {
  useEffect(() => {
    const handler = (event: PromiseRejectionEvent) => {
      if (event.reason?.name === 'ChunkLoadError') {
        reloadOnChunkError();
      }
    };
    window.addEventListener('unhandledrejection', handler);
    return () => window.removeEventListener('unhandledrejection', handler);
  }, []);

  return null;
}
